
import { defineComponent, PropType, ref } from 'vue';

import store from '@/store';
import { Comment } from '@/typings';
import * as timeago from 'timeago.js';

import Subcomment from './Subcomment.vue';
import CreateComment from './CreateComment.vue';

// @ts-ignore
import taskLists from 'markdown-it-task-lists';

export default defineComponent({
	components: {
		Subcomment,
		CreateComment,
	},
	props: {
		comment: {
			type: Object as PropType<Comment>,
		},
	},
	setup() {
		const createDateText = (date: Date) => timeago.format(date);
		const createCommentVisible = ref(false);

		return {
			store,
			createDateText,
			createCommentVisible,
			taskLists,
		};
	},
});
